import { render, staticRenderFns } from "./expenseCategory.vue?vue&type=template&id=6ebb10ea&scoped=true"
import script from "./expenseCategory.vue?vue&type=script&lang=js"
export * from "./expenseCategory.vue?vue&type=script&lang=js"
import style0 from "./expenseCategory.vue?vue&type=style&index=0&id=6ebb10ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb10ea",
  null
  
)

export default component.exports